import { environment } from "src/environments/environment";
// let _baseUrl: string = 'http://ec2-13-235-243-119.ap-south-1.compute.amazonaws.com/';
// let _apiUrl: string = _baseUrl + 'p1devcastindia/api/API/web/V2';

// let _adminBaseUrl: string = 'http://ec2-13-235-243-119.ap-south-1.compute.amazonaws.com/'
// let _adminApiUrl: string = _adminBaseUrl + 'p1devadmincastindia/API/V1'

export class urls {
  // static _baseUrl: string = 'http://ec2-13-235-243-119.ap-south-1.compute.amazonaws.com/';
  static _apiUrl: string = environment.apiUrl;
  // static _adminBaseUrl: string = 'http://ec2-13-235-243-119.ap-south-1.compute.amazonaws.com/';
  // static _adminApiUrl: string = this._adminBaseUrl + 'p1devadmincastindia/API/V1';
  static _websiteUrl: string = environment.websiteUrl;

  // static baseUrl = this._baseUrl;
  static apiUrl = this._apiUrl + '/creators/v1';
  // static adminBaseUrl = this._adminBaseUrl;
  // static adminApiUrl = this._adminApiUrl;
  static privacyPolicyUrl = this._websiteUrl + '/privacy-policy';
  static termsAndConditionsUrl = this._websiteUrl + '/terms-of-service';
  static creatorAgreementUrl = this._websiteUrl + '/creators-agreement';
  // static termsOfUseUrl = this._websiteUrl + '/terms-of-service';
  static confidentialityPolicyUrl = this._websiteUrl + '/security';
  // static legalPrivacyPolicyUrl = this._websiteUrl + '/privacy-policy';
  static eulaUrl = this._websiteUrl + '/user-license';
}
export class regexPatterns {
  public static readonly namePattern = '^([a-zA-Z])+$';
  public static readonly mobilePattern = /^[6789]\d{9}$/;
  public static readonly emailPattern = '^[a-zA-Z0-9]+([.-]?[a-zA-Z0-9]+)*@([a-zA-Z 0-9]+([.-]?[a-zA-Z0-9]{2,}))[.]{1}[a-zA-Z]{2,}$';
  public static readonly alphabaticPattern = '^[a-zA-Z ]{2,}$';
  public static readonly numericPattern = '^[1-9]{1,}$';
  public static readonly urlPattern = 'https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,}';
  public static readonly addressAlphaNumeric = '^[a-zA-Z 0-9,-.]{4,}$';
  public static readonly heightPattern = /^(\d{1,1})\'((\s?)(-?)(\s?)(0[0-9]|(1[0-1]))\ʺ)?$/g;
  public static readonly licenseNumberPattern = '^[a-zA-Z0-9,-./]{4,}$';
  public static readonly yearOfExperiencePattern = /^(\d[0-9]{1,2})\ Y ((\s?)(-?)(\s?)[0-9][0-9]\ M)?$/g;
  public static readonly removeSpecialCharactersPattern = '^[A-Za-z0-9? , _-]+$';
  public static readonly paymentPattern = '^[0-9]{1,}[.]{0,1}[0-9]{0,}$';
  public static readonly onlyNumberPattern = '^[0-9]*$';
  public static readonly chipsAddInputPattern = '[a-zA-Z][0-9a-z()A-z&_/-\s]{1,}';
  public static readonly alphaNumeric = '^[a-zA-Z 0-9]{4,}$';
  public static readonly monthPattern = /^((0[0-9]|(1[0-1])))?$/g;
  public static readonly yearPattern = /^(\d[0-9]{1,2})?$/g;
  public static readonly noticePeriodPattern = '^[0-9]{1,3}$';
  public static readonly pincode = '^[1-9]{1}[0-9]{5}$';
  public static readonly oneAlphabet = '([a-z])+';
  public static readonly imagePattern = '[^\\s]+(.*?)\\.(jpg|jpeg|png|gif)$';
  public static readonly alphaSpecialPattern = "^[a-zA-Z-.' ]{3,}$";
  public static readonly fullNamePattern = "^[a-zA-Z ]*$";
  public static readonly instagramHandlePattern = "^[a-zA-Z0-9]([a-zA-Z0-9]|[_](?![._])|[.](?![._])){0,28}$";
}

export enum routingPath {
  landing = '/landing',
  // dashboard = '/dashboard',
  // verifyAspirantList = '/verify-aspirant-list',
  // completeProfile = '/complete-aspirant-profile',
  // insertEmployer = '/insert-employer',
  // insertJobs = '/insert-jobs',
  // editEmployer = '/edit-company',
  // exportAspirants = '/export-aspirants',
  // VerifyAspirantDetails = '/verify-aspirant-details',
  // editProfile = '/edit-profile'
  introslides = '/intro-slides',
  login = '/login',
  registration = '/registration',
  dashboard = '/dashboard',
  home = '/dashboard/home',
  editor = '/dashboard/editor',
  creatorKit = '/dashboard/creator-kit',
  creatorTools = '/creator-tools',
  socialProfile = '/dashboard/social-profile',
  earnings = '/dashboard/earnings',
  notification = '/notification',
  editProfile = '/edit-profile',
  whatsappSupport = '/whatsapp-support',
  termsAndPolicies = '/terms-and-policies',
  transactionDetails = '/transaction-details',
  projectDetails = '/project-details',
  notificationDetails ='/notification-detail',
  billingDetails ='/billing-details'
}

export enum roles {
  role_all = 0,
  role_telecaller = 1,
  role_verifyer = 2,
  role_data_mgmt = 3,
  role_admin = 4
}
